import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../../components/common/ErrorBoundary';
import ScrollToTop from '../../components/ScrollToTop';
import HeadContainer from './HeadContainer';
import SidebarContainer from './SidebarContainer';
import FooterContainer from './FooterContainer';
import MainPageTemplate from '../../components/template/MainPageTemplate';
import ModalContainerList from './ModalContainerList';
import Core from '../../containers/base/Core.js';
import ErrorSection from '../../components/common/ErrorSection';
import FullscreenLoader from '../../components/base/FullscreenLoader';

const App = () => {
  const isCollapsed = useSelector((state) => state.app.sidebar.isCollapsed);

  return (
    <>
      <ScrollToTop />
      <MainPageTemplate isCollapsed={isCollapsed}>
        <SidebarContainer />
        <HeadContainer />
        <ModalContainerList />
        <ErrorBoundary fallback={({ error, reset }) => <ErrorSection error={error} reset={reset} />}>
          <Suspense fallback={<FullscreenLoader visible={true} />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
        <FooterContainer />
      </MainPageTemplate>
      <Core />
    </>
  );
};

export default App;
